module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_7005.9823623b.png";